<gp-modal [closable]="true" size="xl">
  <div class="gp-modal-title">
    <h4 class="text-ellipsis">
      {{ 'SETTINGS.user_rights.manage_population_access_criterion' | translate }}
    </h4>
  </div>
  <div class="gp-modal-body criterionList">
    <div *ngIf="showConfirmDeletionMessage"
         class="alert flex-center-x-y p-y-sm confirm-deletion-alert">
      <h6 class="m-y-0">
        <em class="fa-duotone fa-diamond-exclamation p-r-sm"></em>
        {{ 'SETTINGS.user_rights.access_criterion_deleted_confirmation_msg' | translate }}
      </h6>
      <div>
        <button (click)="handleDeleteCriterionConfirmation()"
                [disabled]="isOperationInProgress"
                class="btn btn-sm btn-danger p-x-md m-l-md m-r-sm" test-id="confirmButton" type="button">
          <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
          {{ 'FORMS.confirm' | translate }}
        </button>
        <button (click)="discardDeleteCriterion()"
                [disabled]="isOperationInProgress"
                class="btn btn-sm btn-secondary p-x-md" test-id="cancelButton" type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
    <div class="box-body table-responsive">
      <form [formGroup]="managePopulationAccessCriterionForm" class="gp-modal-body clearfix" novalidate>
        <div class="row form-group flex-center-x-y light p-y-xs">
          <div class="col-md-4 text-right">
            <label class="font-weight-bold"
                   for="contractIndexCriteriaZoneName">{{ 'SETTINGS.user_rights.contract_index_criteria_zone' | translate }}
              <span class="required"> *</span>
            </label>
          </div>
          <div class="col-md-3">
            <ng-select
              (removed)="removeSelectZone()"
              (selected)="selectZone($event)"
              [allowClear]="true"
              [attr.test-id]="'contractIndexCriteriaZoneName'"
              [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
              [items]="contractIndexCriteriaZones"
              [placeholder]="'EMPLOYEE_HIRE.select' | translate"
              class="form-control"
              formControlName="contractIndexCriteriaZoneName"
              id="contractIndexCriteriaZoneName">
            </ng-select>
          </div>
          <div class="col-md-4">
            <button (click)="showAddCriterionFormFields()"
                    [disabled]="isInitialState || isContentLoading || isAddOrUpdateActive || isDeleteCriterionActive"
                    class="btn btn-sm btn-primary p-x-md"
                    type="button">
              {{ 'SETTINGS.user_rights.create_new_criterion' | translate }}
            </button>
          </div>
        </div>
      </form>
      <gp-illustrated-message *ngIf="isInitialState; else tableContent"
                              [text]="'SETTINGS.user_rights.manage_population_access_criterion_instruction'"
                              [width]="'40%'">
      </gp-illustrated-message>
      <ng-template #tableContent>
        <form [formGroup]="criterionForm" class="table-wrapper" novalidate>
          <table aria-describedby="zoneCriterionList"
                 class="table table-striped gp-table" id="zoneCriterionList">
            <thead>
            <tr class="text-uppercase text-xs" role="row">
              <th class="p-y-0 w"
                  scope="col" test-id="group-zone-name">
                {{ 'SETTINGS.group_zone_name' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-sm"
                  scope="col" test-id="zone-type">
                {{ 'SETTINGS.zone_type' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-md"
                  scope="col" test-id="zone-value">
                {{ 'FORMS.Value' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-xs" scope="col" test-id="access-mode">
                {{ 'SETTINGS.access_mode' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-xs" scope="col" test-id="actions">
                {{ 'MDU.actions' | translate }}
              </th>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr *ngIf="isContentLoading">
              <td [attr.colspan]="6" class="text-center p-y-lg">
                <em class="fa fa-light fa-spinner fa-spin"></em>
              </td>
            </tr>
            <ng-container *ngIf="isContentLoaded || isAddOrUpdateActive || isDeleteCriterionActive">
              <tr *ngIf="isAddCriterionActive" class="row" role="row">
                <td class="w">
                  {{ selectedZoneGroup }}
                </td>
                <td class="w-sm">
                  {{ selectedZoneType }}
                </td>
                <td class="w-md">
                  <ng-container [ngSwitch]="selectedZoneType">
                    <gp-tree-select *ngSwitchCase="'LIST'"
                                    [attr.test-id]="'criteriaValue'"
                                    [isSorted]="true"
                                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                    [tree]="selectedZoneMetadata"
                                    [readOnly]="!isAddCriterionActive || isOperationInProgress"
                                    (elementSelected)="zoneSelected($event)"
                                    class="form-control"
                                    formControlName="value"
                                    id="valueList"
                                    ngDefaultControl>
                    </gp-tree-select>

                    <gp-tree-select *ngSwitchCase="'TREE'"
                                    [attr.test-id]="'criteriaValue'"
                                    [isSorted]="true"
                                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                    [tree]="selectedZoneMetadata"
                                    [readOnly]="!isAddCriterionActive || isOperationInProgress"
                                    (elementSelected)="zoneSelected($event)"
                                    class="form-control"
                                    formControlName="value"
                                    id="valueTree"
                                    ngDefaultControl>
                    </gp-tree-select>

                    <ng-container *ngSwitchCase="'ENTITY'">
                      <gp-tree-select
                        *ngIf="selectedZoneMetadata"
                        class="form-control"
                        [attr.test-id]="'criteriaValue'"
                        [url]="selectedZoneMetadata"
                        [responseCallBack]="responseCallback"
                        [lazyValue]="lazyValue"
                        [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                        [isSorted]="true"
                        [readOnly]="!isAddCriterionActive || isOperationInProgress"
                        (elementSelected)="zoneSelected($event)"
                        formControlName="value"
                        id="valueEntity"
                        ngDefaultControl>
                      </gp-tree-select>
                    </ng-container>

                    <datepicker-input *ngSwitchCase="'DATE'"
                                      [attr.test-id]="'criteriaValue'"
                                      [hasEternity]="true"
                                      [isAppendToBody]="false"
                                      id="valueDate"
                                      formControlName="value"
                                      ngDefaultControl>
                    </datepicker-input>

                    <div *ngSwitchCase="'BOOLEAN'">
                        <label class="ui-switch full-access-switch m-l-xs">
                          <input type="checkbox"
                                 [attr.test-id]="'editCriteriaValue'"
                                 [checked]=booleanValueChecked
                                 formControlName="value"
                                 id="valueBoolean">
                          <em></em>
                        </label>
                    </div>

                    <input *ngSwitchDefault
                           [attr.readOnly]="!isAddCriterionActive || isOperationInProgress ? 'true' : null"
                           [attr.test-id]="'criteriaValue'"
                           [placeholder]="'SETTINGS.user_rights.placeholder_criterion_value' | translate"
                           class="form-control"
                           formControlName="value"
                           id="value"
                           type="text"/>
                  </ng-container>

                  <ul
                    [attr.data-hidden]="criterionForm.controls.value.valid || criterionForm.controls.value.pristine"
                    class="error-list">
                    <li *ngIf="criterionForm.controls.value.errors?.maxlength">
                      {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                    </li>
                  </ul>
                </td>
                <td class="w-xs">
                  <ng-select [attr.test-id]="'accessMode'"
                             [disabled]="!isAddCriterionActive || isOperationInProgress"
                             [items]="accessModes"
                             [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                             class="form-control"
                             formControlName="accessMode"
                             id="accessMode">
                  </ng-select>
                </td>
                <td class="flex-center-x-y w-auto">
                  <button (click)="createPopulationAccessCriterion()"
                          [disabled]="criterionForm?.invalid || isOperationInProgress"
                          [tooltip]="'FORMS.save' | translate"
                          class="btn btn-xs text-white btn-primary" type="button">
                    <em *ngIf="!isOperationInProgress" class="fa fa-light fa-check"></em>
                    <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
                  </button>
                  <button (click)="hideAddOrUpdateForm(criterionForm)" [disabled]="!isAddCriterionActive"
                          [tooltip]="'FORMS.cancel' | translate"
                          class="btn btn-xs btn-default" type="button">
                    <em class="fa fa-light fa-times"></em>
                  </button>
                </td>
              </tr>
              <tr *ngFor="let zone of zoneData trackBy: trackByCriterionId"
                  [class.highlight]="zone?.id === criterionToBeDeleted">
                <ng-container *ngIf="(zone?.id !== criterionToBeUpdated); else showEditableRow">
                  <td class="wrap w">{{ zone.groupZoneName}}</td>
                  <td class="w-sm">{{ zone.value[zone?.zoneName]?.type }}</td>
                  <td class="wrap w-md">
                    <ng-container *ngIf="(zone.value[zone?.zoneName]?.type === 'BOOLEAN'); else readableName">
                    <em class="fa fa-light"
                       [ngClass]="(checkBooleanValue(zone)) ? 'fa-check' : 'fa fa-light fa-times'"> </em>
                    </ng-container>

                    <ng-template #readableName>
                      {{ getReadableName(zone) }}
                    </ng-template>
                  </td>
                  <td class="w-xs">{{ zone?.access }}</td>
                  <td class="w-xs">
                    <button (click)="updateCriterion(zone)"
                            [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
                            class="btn btn-xs btn-default"
                            test-id="action-update-criterion"
                            tooltip="{{'TOOLTIPS.edit' | translate}}" type="button">
                      <em class="fa fa-light fa-pencil-alt"></em>
                    </button>
                    <button (click)="deleteCriterion(zone?.id)"
                            [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
                            class="btn btn-xs btn-outline-danger"
                            test-id="action-delete-criterion"
                            tooltip="{{'TOOLTIPS.delete' | translate}}" type="button">
                      <em class="fa fa-light fa-trash-alt"></em>
                    </button>
                  </td>
                </ng-container>
                <ng-template #showEditableRow>
                  <td class="w">
                    {{ selectedZoneGroup }}
                  </td>
                  <td class="w-sm">
                    {{ selectedZoneType }}
                  </td>
                  <td class="w-md">
                    <ng-container [ngSwitch]="selectedZoneType">
                      <gp-tree-select *ngSwitchCase="'LIST'"
                                      [attr.test-id]="'editCriteriaValue'"
                                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                      [tree]="selectedZoneMetadata"
                                      [isSorted]="true"
                                      [readOnly]="isOperationInProgress"
                                      (elementSelected)="zoneSelected($event)"
                                      class="form-control"
                                      formControlName="value"
                                      id="editValueList"
                                      ngDefaultControl>
                      </gp-tree-select>

                      <gp-tree-select *ngSwitchCase="'TREE'"
                                      [attr.test-id]="'editCriteriaValue'"
                                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                      [tree]="selectedZoneMetadata"
                                      [isSorted]="true"
                                      [readOnly]="isOperationInProgress"
                                      (elementSelected)="zoneSelected($event)"
                                      class="form-control"
                                      formControlName="value"
                                      id="editValueTree"
                                      ngDefaultControl>
                      </gp-tree-select>

                      <ng-container *ngSwitchCase="'ENTITY'">
                        <gp-tree-select
                          *ngIf="selectedZoneMetadata"
                          class="form-control"
                          [attr.test-id]="'editCriteriaValue'"
                          [url]="selectedZoneMetadata"
                          [responseCallBack]="responseCallback"
                          [lazyValue]="lazyValue"
                          [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                          formControlName="value"
                          [isSorted]="true"
                          [readOnly]="isOperationInProgress"
                          (elementSelected)="zoneSelected($event)"
                          ngDefaultControl>
                        </gp-tree-select>
                      </ng-container>

                      <datepicker-input *ngSwitchCase="'DATE'"
                                        [attr.test-id]="'editCriteriaValue'"
                                        [hasEternity]="true"
                                        [isAppendToBody]="false"
                                        id="editValueDate"
                                        formControlName="value"
                                        ngDefaultControl>
                      </datepicker-input>

                      <div *ngSwitchCase="'BOOLEAN'">
                        <label class="ui-switch full-access-switch m-l-xs">
                          <input type="checkbox"
                                 [attr.test-id]="'editCriteriaValue'"
                                 [checked]="booleanValueChecked"
                                 formControlName="value"
                                 id="editValueBoolean">
                          <em></em>
                        </label>
                      </div>

                      <input *ngSwitchDefault
                             [attr.test-id]="'editCriteriaValue'"
                             [placeholder]="'SETTINGS.user_rights.placeholder_criterion_value' | translate"
                             [readOnly]="isOperationInProgress"
                             class="form-control text-center"
                             formControlName="value"
                             id="editCriteriaValue"
                             type="text"/>
                    </ng-container>

                    <ul
                      [attr.data-hidden]="criterionForm.controls.value.valid || criterionForm.controls.value.pristine"
                      class="error-list">
                      <li *ngIf="criterionForm.controls.value.errors?.maxlength">
                        {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                      </li>
                    </ul>
                  </td>
                  <td class="w-xs">
                    <ng-select [attr.test-id]="'editAccessMode'"
                               [disabled]="isOperationInProgress"
                               [items]="accessModes"
                               [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                               class="form-control text-center"
                               formControlName="accessMode"
                               id="editAccessMode">
                    </ng-select>
                  </td>
                  <td class="w-xs">
                    <button (click)="updatePopulationAccessCriterion()"
                            [disabled]="criterionForm?.invalid || isOperationInProgress"
                            [tooltip]="'FORMS.save' | translate"
                            class="btn btn-xs text-white btn-primary" type="button">
                      <em *ngIf="!isOperationInProgress" class="fa fa-light fa-check"></em>
                      <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
                    </button>
                    <button (click)="hideAddOrUpdateForm(criterionForm)"
                            [disabled]="!isUpdateCriterionActive || isOperationInProgress"
                            [tooltip]="'FORMS.cancel' | translate"
                            class="btn btn-xs btn-default" type="button">
                      <em class="fa fa-light fa-times"></em>
                    </button>
                  </td>
                </ng-template>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <ng-container *ngIf="isCriterionNotFound" test-id="not-found-message">
            <gp-illustrated-message [text]="'SETTINGS.user_rights.criterion_not_found'"
                                    [width]="'40%'">
            </gp-illustrated-message>
          </ng-container>
        </form>
        <gp-table-pagination
          (pageChange)="pageChanged()"
          [pagination]="pagination"
          [text]="'SETTINGS.user_rights.showing___of_population_access_criterion'">
        </gp-table-pagination>
      </ng-template>
    </div>
  </div>
  <div class="gp-modal-footer"></div>
</gp-modal>
